const getReferralPath = () => {
  return `${window.location.host}/r/`;
};

export const createReferralUrl = (referralCode: string) =>
  `${getReferralPath()}${referralCode}`;

export const createShortReferralUrl = (referralCode: string) =>
  `${getReferralPath().replace("https://", "")}${referralCode}`;
